import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=3586a2bd&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.vue?vue&type=style&index=0&id=3586a2bd&prod&lang=scss&scoped=true"
import style1 from "./Table.vue?vue&type=style&index=1&id=3586a2bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3586a2bd",
  null
  
)

export default component.exports